import { EmeraldCheckbox } from "@emerald-react/checkbox";
import { EmeraldIcon } from "@emerald-react/icon";
import { EmeraldTooltip } from "@emerald-react/tooltip";
import useSurveyState from "@hooks/useSurveyState";
import {
  useUpdateSurveyFlagsMutation,
  useUpdateSurveyTimestampMutation,
} from "@services/survey-core";

const ShareClientControlsSection = () => {
  const { survey } = useSurveyState();
  const [updateSurveyFlags] = useUpdateSurveyFlagsMutation();
  const [updateSurveyTimestamp] = useUpdateSurveyTimestampMutation();

  // Get checkbox values from survey object with defaults
  const allowClientPdfDownload = survey?.isClientPdfDownloadEnabled ?? false;
  const allowComments = survey?.isClientCommentEnabled ?? false;
  const allowShortlisting = survey?.isSurveyShortlistEnabled ?? true;

  const handleCheckboxChange = (name: string) => (checked: boolean) => {
    if (survey) {
      updateSurveyFlags({ id: survey.id, [name]: checked })
        .unwrap()
        .then(() => updateSurveyTimestamp({ surveyId: survey.id }))
        .catch(() => {
          // Error already handled by updateSurveyFlags rollback
        });
    }
  };

  return (
    <>
      {/* Client PDF Download Option */}
      <div className="flex items-center justify-between">
        <EmeraldCheckbox
          id="allowClientPdfDownload"
          checked={allowClientPdfDownload}
          label="Allow PDF Download"
          onChange={handleCheckboxChange("isClientPdfDownloadEnabled")}
        />
        <EmeraldTooltip
          triggerElement={
            <EmeraldIcon
              icon="info_outline"
              type="filled"
              className="text-base! cursor-default"
            />
          }
          delayShow={0}
          delayHide={100}
          followCursor={false}
          visible={false}
          placement={"top"}
        >
          <p className="text-xs">
            This will allow the client to download a PDF of the survey directly
            from the web link they access.
          </p>
        </EmeraldTooltip>
      </div>
      <div className="flex items-center justify-between">
        <EmeraldCheckbox
          id="allowComments"
          checked={allowComments}
          label="Allow Comments"
          onChange={handleCheckboxChange("isClientCommentEnabled")}
        />
        <EmeraldTooltip
          triggerElement={
            <EmeraldIcon
              icon="info_outline"
              type="filled"
              className="text-base! cursor-default"
            />
          }
          delayShow={0}
          delayHide={100}
          followCursor={false}
          visible={false}
          placement={"top"}
        >
          <p className="text-xs">
            This will allow clients to add comments, which will be visible to
            all with access to the web survey.
          </p>
        </EmeraldTooltip>
      </div>
      <div className="flex items-center justify-between">
        <EmeraldCheckbox
          id="allowShortlisting"
          checked={allowShortlisting}
          label="Allow Shortlisting"
          onChange={handleCheckboxChange("isSurveyShortlistEnabled")}
        />
        <EmeraldTooltip
          triggerElement={
            <EmeraldIcon
              icon="info_outline"
              type="filled"
              className="text-base! cursor-default"
            />
          }
          delayShow={0}
          delayHide={100}
          followCursor={false}
          visible={false}
          placement={"top"}
        >
          <p className="text-xs">
            This will allow clients to shortlist the properties, which will be
            visible to all with access to the web survey.
          </p>
        </EmeraldTooltip>
      </div>
    </>
  );
};

export default ShareClientControlsSection;
